



























import Vue from 'vue';
import CustomerHelper from '@/helpers/CustomerHelper';
import EventListenerHelper from '../../helpers/EventListenerHelper';
import SingleProductComplement from '../layout/SingleProductComplement.vue';
import Slider from '../layout/Slider.vue';
import { IEventListener } from '../../common/interfaces/index.interface';
import { IProduct } from '../../common/interfaces/products.interface';
import { IHomepageOffersTranslations } from '../../common/interfaces/translations/homepage-offers.translations.interface';

interface IHomepageOffersComponent {
  currency: boolean;
  limitingActive: boolean;
  loading: boolean;
  mountedDocumentEventListeners: IEventListener[];
  products: IProduct[];
  vueHomepageOffersTexts: IHomepageOffersTranslations;
}

export default Vue.extend({
  components: { SingleProductComplement, Slider },
  data(): IHomepageOffersComponent {
    return {
      currency: false,
      limitingActive: false,
      loading: true,
      mountedDocumentEventListeners: [],
      products: [],
      vueHomepageOffersTexts: window.vueHomepageOffersTexts,
    };
  },
  props: {
    shoppingAllowed: {
      default: true,
      type: Boolean,
    },
  },
  async mounted(): Promise<void> {
    CustomerHelper.setABTestForTestGroup(`2021-04-28`);
    this.products = await this.$productService.getHomepageOfferProducts();
    this.loading = false;
  },
  beforeDestroy(): void {
    EventListenerHelper.teardownEventListeners(this.mountedDocumentEventListeners);
  },
});
